import { connect } from 'react-redux';
import React, { Component } from 'react';

import {http_methods} from '../utils';
import {default_policy, prepare, submit} from '../request_client';

import md from 'markdown-it';
import md_checkbox from 'markdown-it-checkbox';
import markdown_style from 'github-markdown-css';

import {resolve_refs, strip_props, spec_validator} from '../spec_utils';
import yaml from 'js-yaml';

import MethodBadge from './MethodBadge';
import TagBadge from './TagBadge';
import SplitPanel from './SplitPanel';
import Pane from './Pane';
import DocView from './DocView';
import {Card, CardActions, CardHeader, CardText, FlatButton, Paper, Divider, TextField, SelectField, MenuItem, Dialog} from 'material-ui';
import Method from './Method';

const MethodsNode = props => {
  const {spec, node, route, path, path_params, tags = [], filters = [], policy = {}} = props;
  return <div className="api-info__method">
    {Object.keys(node).map(method => {
      const node_policy = _.defaultsDeep({}, node[method].policy, policy);
      return <Method key={method} type={method} path={path} path_params={path_params} spec={spec} node={node[method]} parent_tags={tags} filters={filters} policy={node_policy}/>;
    })}
  </div>;
};

export default MethodsNode;
